import React from 'react';
import {Box} from "@mui/material";
import {BankBullet, BankText} from '../../views/payment/styles/bankInfoStyles';


const bankArray: string[] = [
  'You are one step away from completing the process of adding this payment method.',
  'You must now verify your  bank account by confirming 2 micro deposit amounts.',
  'Two small deposits will be made into your bank account within 1-2 days.',
  'The deposit amount will be less than $0.10.',
  'Once you see the deposits, come back to this page and click the "Verify" button.',
  'Follow the remaining steps to verify and you\u2019re all done!'
];

const MicrodepositVerificationSteps = () => {
  return (
    <>
      {bankArray.map((item) => (
        <Box display='flex' alignItems='center' key={item}>
          <BankBullet/>
          <BankText variant='body1'>{item}</BankText>
        </Box>
      ))}
    </>
  );
}

export default MicrodepositVerificationSteps;
